<template>
    <div id="dash_modules" v-if="modules.length > 0">
        <div class="module_container">
            <div class="module_shadow">
                <div class="module_header row no_wrap align_center justify_between">
                    <div class="span_auto">
                        <h2>{{ intro_module.fields.module_title }}</h2>
                    </div>
                </div>
                <div class="module_copy row">
                    <div class="span_6_xs">
                        <p class="module_body_header">Introduction</p>
                        <div v-html="markdown(intro_module.fields.module_introduction)"></div>
                    </div>
                    <div class="span_6_xs">
                        <p class="module_body_header">Learning Objectives</p>
                        <div v-html="markdown(intro_module.fields.learning_objectives)"></div>
                    </div>
                </div>
            </div>
            <div class="materials_container" v-if="intro_module.fields.related_materials" :data-module="'intro_module'" :class="{ open: collapsed.intro_module }">
                <div class="materials_header row align_center justify_between" @click="collapse_toggle('intro_module')">
                    <div class="span_auto">
                        <p>EDUCATOR MATERIALS &amp; PRINTABLES</p>
                    </div>
                    <div v-if="!collapsed.intro_module" class="span_auto">
                        <a class="collapse_link">Open <i class="fa fa-caret-down" aria-hidden="true"></i></a>
                    </div>
                    <div v-else class="span_auto">
                        <a class="collapse_link">Close <i class="fa fa-caret-up" aria-hidden="true"></i></a>
                    </div>
                </div>
                <div class="materials_list" :data-module="'intro_module'">
                    <div v-for="item of intro_module.fields.related_materials" class="download_row row justify_between">
                        <div class="span_auto">
                            <p class="download_title"><i class="fa fa-file" aria-hidden="true"></i>{{ item.fields.file.fileName }}</p>
                        </div>
                        <div class="span_auto">
                            <a class="download_link" :href="item.fields.file.url" download>Download<i class="fa fa-download" aria-hidden="true"></i></a>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div :id="'module_' + module.module_number" class="module_container" v-for="module of modules">
            <div class="module_shadow">
                <div class="module_header row no_wrap align_center justify_between">
                    <div class="span_10_xs">
                        <h2>{{ module.module_title }}</h2>
                    </div>
                    <div class="span_auto">
                        <a v-if="module.active" class="bttn dash_bttn" target="_blank" :href="'/module-' + module.module_number">Launch Animation</a>
                        <span v-else class="paragraph" :style="{color: 'white'}">Coming Soon</span>
                    </div>
                </div>
                <div class="module_copy row">
                    <div class="span_6_xs">
                        <p class="module_body_header">Introduction</p>
                        <div v-html="markdown(module.module_introduction)"></div>
                    </div>
                    <div class="span_6_xs">
                        <p class="module_body_header">Learning Objectives</p>
                        <div v-html="markdown(module.learning_objectives)"></div>
                    </div>
                </div>
            </div>
            <div class="materials_container" v-if="module.related_materials" :data-module="module.module_number" :class="{ open: collapsed['module_' + module.module_number] }">
                <div class="materials_header row align_center justify_between" @click="collapse_toggle(module.module_number)">
                    <div class="span_auto">
                        <p>EDUCATOR MATERIALS &amp; PRINTABLES</p>
                    </div>
                    <div v-if="!collapsed['module_' + module.module_number]" class="span_auto">
                        <a class="collapse_link">Open <i class="fa fa-caret-down" aria-hidden="true"></i></a>
                    </div>
                    <div v-else class="span_auto">
                        <a class="collapse_link">Close <i class="fa fa-caret-up" aria-hidden="true"></i></a>
                    </div>
                </div>
                <div class="materials_list" :data-module="module.module_number">
                    <div v-for="item of module.related_materials" class="download_row row justify_between">
                        <div class="span_auto">
                            <p class="download_title"><i class="fa fa-file" aria-hidden="true"></i>{{ item.fields.file.fileName }}</p>
                        </div>
                        <div class="span_auto">
                            <a class="download_link" :href="item.fields.file.url" download>Download<i class="fa fa-download" aria-hidden="true"></i></a>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import * as contentful from 'contentful';
    import markdown from '../../../mixins/markdown.js';
    import anime from 'animejs';

    export default {
        data() {
            return {
                modules: [],
                intro_module: null,
                collapsed: {
                    intro_module: false
                }
            }
        },
        mixins: [markdown],
        mounted() {
            const content_client = contentful.createClient({
                space: process.env.SPACE_ID,
                accessToken: process.env.CMS_TOKEN
            });

            content_client.getEntries({
                content_type: 'dashboard_module',
				order: 'fields.module_number'
            }).then((response) => {

				this.modules = response.items.filter((item) => {
                    if (item.fields.module_number) {
                        return true;
                    } else {
                        this.intro_module = item;
                        return false;
                    }
                }).map((item) => {
                    this.$set(this.collapsed, 'module_' + item.fields.module_number, false);
                    return item.fields;
				});
            }).catch(console.error);
        },
        methods: {
			collapse_toggle(module_number) {
				let target = document.querySelector('.materials_list[data-module="' + module_number + '"]');
				let target_height = target.getBoundingClientRect().height + 48;

                if (module_number == 'intro_module') {
                    if (this.collapsed.intro_module) {
    					this.collapsed.intro_module = false;
    					anime({
    						targets: '.materials_container[data-module="' + module_number + '"]',
    						height: [target_height, '48px'],
    						easing: 'easeOutCubic',
    						duration: 300
    					});
    				} else if (!this.collapsed.intro_module) {
    					this.collapsed.intro_module = true;
    					anime({
    						targets: '.materials_container[data-module="' + module_number + '"]',
    						height: ['48px', target_height],
    						easing: 'easeOutCubic',
    						duration: 300
    					});
    				}
                } else {
                    if (this.collapsed['module_' + module_number]) {
                        this.collapsed['module_' + module_number] = false;
                        anime({
                            targets: '.materials_container[data-module="' + module_number + '"]',
                            height: [target_height, '48px'],
                            easing: 'easeOutCubic',
                            duration: 300
                        });
                    } else if (!this.collapsed['module_' + module_number]) {
                        this.collapsed['module_' + module_number] = true;
                        anime({
                            targets: '.materials_container[data-module="' + module_number + '"]',
                            height: ['48px', target_height],
                            easing: 'easeOutCubic',
                            duration: 300
                        });
                    }
                }

			}
        }
    }
</script>



// WEBPACK FOOTER //
// dash_modules.vue?5fc1e1cc